module.exports = __webpack_public_path__ + "img/woshi1.4d3a3bc3.png";